import React, { useState } from "react";

const PaymentSettings = () => {
  const [saveSetup, setSaveSetup] = useState(false);

  const handleSetupComplete = () => {
    setSaveSetup(!saveSetup);
  };

  // Function to close the popup
  const closePopup = () => {
    setSaveSetup(false);
  };

  return (
    <>
      {/* <div className="w-full h-[1200px] flex items-center justify-center"> */}
      <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col pt-[31px] pl-[37px] pr-[58px] pb-[35px]">
        <h3 className="w-[140px] h-[24px] text-black text-start font-semibold text-[16px]">
          Payment
        </h3>
        <hr className="w-[152px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />
        <div className="mt-[27px] bg-white rounded-[10px] w-[919px] h-[804px] pt-[30px] px-[32px] pb-[23px] flex flex-col shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
          <div className="flex flex-row items-center justify-between h-[82px] w-[245px]">
            <p className="w-[82px] h-[82px] bg-[#F8F8F8] rounded-full flex items-center justify-center">
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1007_17983)">
                  <path
                    d="M31.875 15V9.375C31.875 8.87772 31.6775 8.40081 31.3258 8.04918C30.9742 7.69754 30.4973 7.5 30 7.5H11.25C10.2554 7.5 9.30161 7.89509 8.59835 8.59835C7.89509 9.30161 7.5 10.2554 7.5 11.25M7.5 11.25C7.5 12.2446 7.89509 13.1984 8.59835 13.9017C9.30161 14.6049 10.2554 15 11.25 15H33.75C34.2473 15 34.7242 15.1975 35.0758 15.5492C35.4275 15.9008 35.625 16.3777 35.625 16.875V22.5M7.5 11.25V33.75C7.5 34.7446 7.89509 35.6984 8.59835 36.4017C9.30161 37.1049 10.2554 37.5 11.25 37.5H33.75C34.2473 37.5 34.7242 37.3025 35.0758 36.9508C35.4275 36.5992 35.625 36.1223 35.625 35.625V30"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M37.5 22.5V30H30C29.0054 30 28.0516 29.6049 27.3484 28.9017C26.6451 28.1984 26.25 27.2446 26.25 26.25C26.25 25.2554 26.6451 24.3016 27.3484 23.5984C28.0516 22.8951 29.0054 22.5 30 22.5H37.5Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1007_17983">
                    <rect width="45" height="45" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </p>
            <p className="w-[141px] h-[27px] font-semibold text-[18px] text-black">
              Setup Payment
            </p>
          </div>

          <div className="flex justify-between mt-[28px]">
            <div className="flex flex-col h-[84px] justify-between">
              <p className="w-[107px] h-[21px] text-black text-start font-semibold text-[14px]">
                Account Name
              </p>
              <input
                type="text"
                placeholder="Rahul Sharma and Company Pvt . Ltd."
                className="p-[12px] border rounded-[5px] w-[412px] h-[51px] placeholder:w-[267px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
              />
            </div>
            <div className="flex flex-col h-[84px] justify-between">
              <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
                Account Number
              </p>
              <input
                type="text"
                placeholder="SBI1234567890"
                className="p-[12px] border rounded-[5px] w-[412px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
              />
            </div>
          </div>

          <div className="flex flex-col h-[84px] justify-between mt-[22px]">
            <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
              Bank Name
            </p>
            <input
              type="text"
              placeholder="State Bank of India"
              className="p-[12px] border rounded-[5px] w-[855px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
            />
          </div>

          <div className="flex flex-col h-[143px] justify-between mt-[22px]">
            <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
              Bank Address
            </p>
            <textarea
              name="BankAddress"
              id="BankAddress"
              rows={5}
              placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. "
              className="w-[855px] h-[110px] p-[12px] border rounded-[5px] placeholder:w-[819px] placeholder:h-[87px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
            ></textarea>
          </div>

          <div className="flex flex-wrap gap-x-[31px] gap-y-[22px] mt-[22px]">
            <div className="flex flex-col h-[84px] justify-between">
              <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
                Account Number
              </p>
              <input
                type="text"
                placeholder="SBI1234567890"
                className="p-[12px] border rounded-[5px] w-[412px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
              />
            </div>{" "}
            <div className="flex flex-col h-[84px] justify-between">
              <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
                Account Number
              </p>
              <input
                type="text"
                placeholder="SBI1234567890"
                className="p-[12px] border rounded-[5px] w-[412px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
              />
            </div>{" "}
            <div className="flex flex-col h-[84px] justify-between">
              <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
                Account Number
              </p>
              <input
                type="text"
                placeholder="SBI1234567890"
                className="p-[12px] border rounded-[5px] w-[412px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
              />
            </div>{" "}
            <div className="flex flex-col h-[84px] justify-between">
              <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
                Account Number
              </p>
              <input
                type="text"
                placeholder="SBI1234567890"
                className="p-[12px] border rounded-[5px] w-[412px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black"
              />
            </div>
          </div>

          <div className="w-full items-center justify-center text-center flex mt-[33px] h-[41px]">
            <button
              className="w-[104px] h-[41px] bg-[#FF6300] rounded-[5px] flex items-center justify-center text-white font-semibold text-[14px]"
              onClick={handleSetupComplete}
            >
              Save
            </button>
          </div>

          {saveSetup && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-[652px] h-[370px] bg-white rounded-[10px] flex items-center justify-center flex-col">
                <p className="w-[107px] h-[107px] bg-[#0097B2] rounded-full flex items-center justify-center">
                  <svg
                    width="60"
                    height="46"
                    viewBox="0 0 60 46"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.1983 42.8495C21.5731 43.477 20.6874 44 19.9059 44C19.1245 44 18.2388 43.4509 17.5876 42.8233L3 28.1805L7.63676 23.5261L19.932 35.868L52.4414 3L57 7.73278L22.1983 42.8495Z"
                      fill="white"
                      stroke="white"
                      stroke-width="3"
                    />
                  </svg>
                </p>
                <h3 className="w-[158px] h-[30px] text-black font-semibold text-[16px] mt-[28px] text-center">
                  Setup Done
                </h3>
                <p className="w-[346px] h-[26px] text-center text-black font-semibold text-[14px] mt-[12px]">
                  Your payment setup is complete
                </p>
                <button
                  className="w-[95px] h-[42px] bg-white rounded-[10px] font-medium text-[14px] text-black border mt-[33px]"
                  onClick={closePopup}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default PaymentSettings;
